module.exports = __webpack_public_path__ + "static/media/duplicate.4e6caf4b.svg";